import createAction from '../services/create-action';

export const REMOVE_TEXT_EDITOR_ENTITY = 'textEditor/REMOVE_ENTITY';

export const removeTextEditorEntity = createAction(REMOVE_TEXT_EDITOR_ENTITY);



// WEBPACK FOOTER //
// ./app/actions/remove-text-editor-entity.js